<div class="card shadow-sm mb-4">
    <div class="card-body">
        @if (!canAddCompany) {
            <div class="alert alert-info mb-3" role="alert">
                Companies limit is reached. Please upgrade to premium version to add and manage multiple companies
            </div>
        }
        <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="card-title mb-0">Companies ({{ companies().length }})</h5>
            @if (!showAddCompanyForm) {
                @if (!canAddCompany) {
                    <button type="button" class="btn btn-premium btn-sm" (click)="onPremiumAddCompanyClick()">
                        <i class="bi bi-star-fill"></i> Add Company
                    </button>
                } @else {
                    <button type="button" class="btn btn-outline-success btn-sm" (click)="toggleAddCompanyForm()">
                        Add Company
                    </button>
                }
            }
        </div>

        @if (showAddCompanyForm) {
            <form [formGroup]="companyForm" (ngSubmit)="onSubmit()" class="mb-4" novalidate autocomplete="off">
                <div class="row gy-4">
                    <div class="col-md-4">
                        <input type="text" class="form-control" placeholder="Company Name*" formControlName="companyName"
                            [ngClass]="{'is-invalid': companyForm.get('companyName')?.invalid && companyForm.get('companyName')?.touched}" />
                    </div>
                    <div class="col-md-2">
                        <input type="checkbox" class="form-check-input ms-1 me-1" formControlName="isPrimary" />Is Primary
                    </div>
                    <div class="col-md-4">
                        <input id="companyEmail" type="email" class="form-control" placeholder="Email*" formControlName="companyEmail"
                            [ngClass]="{'is-invalid': companyForm.get('companyEmail')?.invalid && companyForm.get('companyEmail')?.touched}" />
                    </div>
                    <div class="col-md-6">
                        <input type="text" class="form-control" placeholder="Phone" formControlName="companyPhone" />
                    </div>
                    <div class="col-md-6">
                        <input type="text" class="form-control" placeholder="Website" formControlName="companyWebsite" />
                    </div>
                    <div class="col-md-12">
                        <input type="text" class="form-control" placeholder="Address*" formControlName="companyAddress"
                            [ngClass]="{'is-invalid': companyForm.get('companyAddress')?.invalid && companyForm.get('companyAddress')?.touched}" />
                    </div>
                    <div class="col-md-4">
                        <input type="text" class="form-control" placeholder="City*" formControlName="companyCity"
                            [ngClass]="{'is-invalid': companyForm.get('companyCity')?.invalid && companyForm.get('companyCity')?.touched}" />
                    </div>
                    <div class="col-md-4">
                        <input type="text" class="form-control" placeholder="Province*" formControlName="companyProvince"
                            [ngClass]="{'is-invalid': companyForm.get('companyProvince')?.invalid && companyForm.get('companyProvince')?.touched}" />
                    </div>
                    <div class="col-md-4">
                        <input type="text" class="form-control" placeholder="Postal Code*" formControlName="companyPostalCode"
                            [ngClass]="{'is-invalid': companyForm.get('companyPostalCode')?.invalid && companyForm.get('companyPostalCode')?.touched}" />
                    </div>
                    <div class="col-md-6">
                        <select class="form-select" formControlName="companyCountry"
                            [ngClass]="{'is-invalid': companyForm.get('companyCountry')?.invalid && companyForm.get('companyCountry')?.touched}">
                            <option value="Canada">Canada</option>
                            <option value="USA">USA</option>
                            <option value="India">India</option>
                            <option value="Europe">Europe</option>
                            <option value="UK">UK</option>
                        </select>
                    </div>
                    <div class="col-md-3">
                        <input type="text" class="form-control" placeholder="GST" formControlName="companyGst" />
                    </div>
                    <div class="col-md-3">
                        <input type="text" class="form-control" placeholder="HST" formControlName="companyHst" />
                    </div>
                    <div class="col-md-12 d-flex gap-2">
                        <button type="submit" class="btn btn-outline-success btn-sm" [disabled]="companyForm.invalid">
                            {{ editingCompanyId ? 'Update Company' : 'Save Company' }}
                        </button>
                        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="toggleAddCompanyForm()">
                            Cancel
                        </button>
                    </div>
                </div>
            </form>
        }

        <div class="table-responsive">
            <table class="table table-hover align-middle mb-0">
                <thead class="table-light">
                    <tr>
                        <th>Name</th>
                        <th class="d-none d-sm-table-cell">Email</th>
                        <th class="d-none d-sm-table-cell">City</th>
                        <th>IsPrimary</th>
                        <th class="text-end">Action</th>
                    </tr>
                </thead>

                <tbody>
                    @for(item of companies(); track $index; let i = $index;){
                        <tr>
                            <td>{{item.name}}</td>
                            <td class="d-none d-sm-table-cell">{{item.email}}</td>
                            <td class="d-none d-sm-table-cell">{{item.address.city}}</td>
                            <td>
                                <span [className]="'badge ' + (item.isPrimary ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger')">
                                    {{item.isPrimary}}
                                </span>
                            </td>
                            <td class="text-end">
                                <div class="d-flex flex-column flex-md-row gap-2 justify-content-end">
                                    <button type="button" class="btn btn-outline-primary btn-sm" (click)="editCompany(item)">Edit</button>
                                </div>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</div>
